import { Close } from '@/components/icons'
import { PlayerSponsor } from '@/types'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { ButtonPrimary } from '../button'

type Props = {
  open: boolean
  onClose: () => void
  sponsor: PlayerSponsor
}

export const SponsoredModal = ({ open, onClose, sponsor }: Props) => {
  const redirectToSponsor = () => {
    if (sponsor.sponsorRedirectUrl) {
      window.open(sponsor.sponsorRedirectUrl, '_blank')
    }
  }

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white py-4 px-6 text-left align-middle shadow-xl transition-all relative">
                <button
                  className="w-9 h-9 rounded-full bg-navy-900 bg-opacity-10 flex items-center justify-center ml-2 hover:bg-opacity-20 absolute right-2 top-2"
                  onClick={onClose}
                >
                  <Close className="text-navy-900" />
                </button>
                <Dialog.Title as="h3" className="text-xl text-navy-900 font-semibold">
                  {sponsor.buttonText}
                </Dialog.Title>

                <div className="mt-4">
                  <div
                    className="text-navy-900 text-opacity-70 text-sm px-6 text-center"
                    dangerouslySetInnerHTML={{
                      __html: sponsor.description as string,
                    }}
                  />
                </div>

                <div className="flex justify-center mt-8">
                  <ButtonPrimary
                    title={sponsor?.buttonText as string}
                    className={`flex items-center justify-center !rounded !py-2 !px-6`}
                    onClick={redirectToSponsor}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
